import InterestAnswerBar from "./InterestAnswerBar";

export default InterestAnswerBar;
